<!--
 * @Author: Ximen
 * @Date: 2021-03-17 15:16:02
 * @LastEditors: Ximen
 * @LastEditTime: 2021-03-31 17:44:23
-->
<template>
  <div id="app">
    <Header />
    <router-view v-slot="{ Component }">
        <component :is="Component" />
    </router-view>
  </div>
</template>
<script>
import Header from '@/components/Header.vue';

export default {
  name: 'App',
  data() {
    return {
    };
  },
  components: {
    Header,
  },
};
</script>

<style lang="stylus">
#app
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
</style>
